import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import strings from "../../utils/strings";
import { useNavigate } from "react-router-dom";

const Tnc = () => {
  const nav = useNavigate();

  const privilege = useSelector((state) => state.verifyType.privilege);
  useEffect(() => {
    switch (true) {
      case privilege.hasTNCright:
        nav(strings.navigation.termsCondition);
        break;
      case privilege.hasPatientProfileRight:
        nav(strings.navigation.patientProfile);
        break;
      case privilege.hasNationalIdRight:
        nav(strings.navigation.nationalID);
        break;
      case privilege.hasDepartmentRight:
        nav(strings.navigation.department);
        break;
      case privilege.hasArticleRight:
        nav(strings.navigation.healthArticle);
        break;
    }
  }, [privilege]);
  return (
    <>
      <Outlet />
    </>
  );
};

export default Tnc;
